import React from 'react';
import { useInView } from 'react-intersection-observer';
import styles from './Clients.module.css'; // We'll create this next

// Combine and deduplicate all logos
const allLogosData = [
  // ... (copy all logo URLs from logosRow1_data and logosRow2_data here)

  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470579/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/txzkhiqckxvf1ox3kayu.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/d8yui5mu2aab1vwq3gnp.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/ysytws6si1eukrqklvyq.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470577/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/fxe2cr1haqsbgrog3v88.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/il5mbvcholynfmuepqvx.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/dxsxmetflyg5ovzdl5jt.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/ftjoglvbxzge5itg9a0g.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470576/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/imabj7tv92r0krnqyez6.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/bzwicrakh33tehvrmbsi.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/rkj17pd9n2vhmuysp58z.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470575/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/f5vzoo2gs3fgd6hlkjp4.png",
    "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470580/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/crcoqphljkmx1o4xahxg.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470579/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/txzkhiqckxvf1ox3kayu.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470579/Digisavvy/REAL%20ESTATE%20CLIENTSLOGOS/k48p8ebiwlurnfnwohsi.png",

  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/BUILDERS%20LOGOS/qthghu942tlauiymegji.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/pv1spqeptdqwei5ecu69.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/jbxaj2gbooge9lvvllxo.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/jghriejveqnijdj7wmpb.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/w0bamd7prwbecb8dzg3e.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/ruil4f9lvu4rrruyaupx.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470564/Digisavvy/BUILDERS%20LOGOS/dgjnfjokmt1dtimnpn3b.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/g8rb2grz1goldvzajrje.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/wjpsg7tngjcsgjp1kd34.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/xdubloqdhv0gistklqyv.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/lhty6hrjrxfpgrehqaut.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/ymsxece7cgimcoexpkux.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470563/Digisavvy/BUILDERS%20LOGOS/nfo0owbbisvhq6dkbiy7.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470573/Digisavvy/Other%20Brands%20LOGOS/bje9clswhlt4fimttids.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470573/Digisavvy/Other%20Brands%20LOGOS/myahmvb90gcrfqm53ize.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470573/Digisavvy/Other%20Brands%20LOGOS/bhpmxsqmkmkatvtxpopn.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470573/Digisavvy/Other%20Brands%20LOGOS/sms36kqwgwgztlk8r45m.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470573/Digisavvy/Other%20Brands%20LOGOS/dubonjsn6orhgk3cesgv.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470572/Digisavvy/Other%20Brands%20LOGOS/hlvhimwn2giqplcvsw2t.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470572/Digisavvy/Other%20Brands%20LOGOS/qd3imxg3ekqmxsxli1ju.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470572/Digisavvy/Other%20Brands%20LOGOS/bflfyshzbyfdf7kqjkre.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470572/Digisavvy/Other%20Brands%20LOGOS/s23awnpfkcqyjzo4irtn.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470572/Digisavvy/Other%20Brands%20LOGOS/uffluoanefxxj6nxpw7t.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470566/Digisavvy/Other%20Brands%20LOGOS/hof9ylxysfgeeixyvw8w.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/oyu0ogfepsgbycdingpr.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/iayurgxz6rpbsji9jwwt.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/djpmvz9elthxk5ysn0gu.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/cm6eawvuizwql2qhcxwf.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/ubcydeh1swxxamjch0m2.png",
  "https://res.cloudinary.com/ddkyeuhk8/image/upload/v1707470565/Digisavvy/Other%20Brands%20LOGOS/awnrooxxjdfchwlcfssn.png",
];
const uniqueLogos = [...new Set(allLogosData)];


// Helper component to wrap elements that should animate on scroll
const AnimateInViewWrapper = ({ children, delaySeconds = 0, threshold = 0.1, triggerOnce = true, className = '' }) => {
  const { ref, inView } = useInView({
    threshold: threshold,
    triggerOnce: triggerOnce,
  });

  return (
    <div
      ref={ref}
      className={`${styles.animateOnScroll} ${inView ? styles.visible : ''} ${className}`}
      style={{ transitionDelay: `${delaySeconds}s` }}
    >
      {children}
    </div>
  );
};

function Clients() {
  return (
    <section className={styles.clientsPageContainer}>
      
<div style={{width:'100%' , height:"100%"}}>
        <img style={{width:'100%' , height:"100%"}} src='https://res.cloudinary.com/ddkyeuhk8/image/upload/v1747508491/SIDE%20BANNER/wuqaurbivxoa4p1kvx2c.png' alt='hero' />
      </div>
      {/* Main Content Hub */}
      <div className={styles.contentHub}>
        <div className={styles.textHeaderContainer}>
          <AnimateInViewWrapper delaySeconds={0.1}>
            <h3 className={styles.hashtagTitle}>#रोटी कपड़ा और मकान</h3>
          </AnimateInViewWrapper>

          <AnimateInViewWrapper delaySeconds={0.2}>
            <h2 className={styles.mainTitle}>The Buzz Brands</h2>
          </AnimateInViewWrapper>

          <AnimateInViewWrapper delaySeconds={0.3}>
            <p className={styles.subtitle}>
              Businesses that started as clients and ended up becoming our best applauders.
            </p>
          </AnimateInViewWrapper>
        </div>

        <AnimateInViewWrapper delaySeconds={0.4} className={styles.logoGridContainerAnimate}>
          <div className={styles.logoGrid}>
            {uniqueLogos.map((url, index) => (
              <div key={`client-logo-${index}`} className={styles.logoCard}>
                <img src={url} alt={`Client Logo ${index + 1}`} className={styles.logoImage} />
              </div>
            ))}
          </div>
        </AnimateInViewWrapper>
      </div>
      <p style={{marginBottom:"40px"}}>For some brands, we manage marketing and promotions via their associates, not directly with the brands.</p>
    </section>
  );
}

export default Clients;